import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import React from 'react';

export const CustomIntlProviderComponent = ({ children, locale, messages }) => (
  <IntlProvider key={locale} locale={locale} messages={messages}>
    {children}
  </IntlProvider>
);

CustomIntlProviderComponent.displayName = 'CustomIntlProviderComponent';

export default connect(
  ({
    journeyBuilderArea: {
      JourneyBuilderSettings: {
        localeInfo: { locale, messages },
      },
    },
  }) => ({
    locale,
    messages,
  })
)(CustomIntlProviderComponent);



// WEBPACK FOOTER //
// ./src/Shared/CustomIntlProvider/index.js